import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const DiscountInfoStripWrapper = styled.div`
  position: sticky;
  padding: ${({ theme }: any) => theme?.discountInfoStrip?.padding};
  color: ${({ theme }: any) => theme?.discountInfoStrip?.color || theme?.primaryText};
  left: 0;
  top: ${({ theme }: ThemeStyle) => theme.headerHeight || "52px"};
  width: 100%;
  z-index: 2;
  margin-top: -6px;
  background: ${({ theme }: any) => theme?.colors?.discountStripBg};
  border: none;
  border-radius: 0;
  text-align: ${({ theme }: any) => theme?.discountInfoStrip?.textAlign};
`;
